<div class="login-block">

  <div class="login-card" fxLayout="row" fxLayoutAlign="center center">
    <mat-icon class="logo" [svgIcon]="'favicon'"></mat-icon>
  </div>

  <mat-card class="login-card">
    <mat-card-content>
      <form #loginForm="ngForm"
            class="login-form" (ngSubmit)="submitLogin($event)">
        <mat-form-field>
          <mat-label [class.form-error]="email.errors?.['required']">メールアドレス</mat-label>
          <input matInput
                 type="email"
                 name="email"
                 placeholder="メールアドレス"
                 id="inputEmail"
                 #email="ngModel"
                 [(ngModel)]="account.email"
                 autocomplete="username email"
                 required>
        </mat-form-field>

        <mat-form-field>
          <mat-label [class.form-error]="password.errors?.['required']">パスワード</mat-label>
          <input matInput
                 [type]="!showPassword ? 'password' : 'text'"
                 placeholder="パスワード"
                 id="inputPassword"
                 [(ngModel)]="account.password"
                 name="password"
                 #password="ngModel"
                 required>
          <!--          https://j-xaas.github.io/Angular-mat-input-password%E3%81%AE%E8%A1%A8%E7%A4%BA-%E9%9D%9E%E8%A1%A8%E7%A4%BA-%E3%82%92%E5%88%87%E3%82%8A%E6%9B%BF%E3%81%88%E3%82%8B%E3%82%A2%E3%82%A4%E3%82%B3%E3%83%B3%E3%82%92%E5%AE%9F%E8%A3%85/-->
          <!--目のアイコンの押下で入力値の表示を切り替え--->
          <button mat-icon-button
                  matSuffix type="button"
                  (click)="showPassword = !showPassword"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="showPassword"
          >
            <mat-icon>{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>

        </mat-form-field>
        <button mat-button
                type="submit"
                color="primary"
                [disabled]="!!loginForm.invalid">
          ログイン
        </button>
      </form>
      <div class="forget-password">
        <button mat-button color="light" (click)="sendPasswordResetEmail()">
          パスワードを忘れた場合
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
